import {
	API_GET_ALL_SPECIALTY,
	API_ADMIN_GET_ALL_SPECIALTY,
	API_ADMIN_GET_SPECIALTY,
	ADMIN_INIT_NEW_SPECIALTY,
    ADMIN_RESET_FOCUS_SPECIALTY,
    API_ADMIN_POST_SPECIALTY,
    API_ADMIN_PATCH_SPECIALTY,
    API_ADMIN_DELETE_SPECIALTY
} from 'actions/specialty';

export function getAllSpecialties() {
	return {
		type: API_GET_ALL_SPECIALTY,
		payload: {
			request: {
				url: `/specialties`
			}
		}
	};
}

export function adminGetAllSpecialties() {
	return {
		type: API_ADMIN_GET_ALL_SPECIALTY,
		payload: {
			request: {
				url: `/admin/specialties`
			}
		}
	};
}

export function adminGetSpecialty(specialty) {
	return {
		type: API_ADMIN_GET_SPECIALTY,
		payload: {
			request: {
				url: `/admin/specialties/${specialty.id}`
			}
		}
	};
}

export function adminPostSpecialty(specialty) {
    return {
        type: API_ADMIN_POST_SPECIALTY,
        payload: {
            request: {
                url: `/admin/specialties`,
                method: "POST",
                data: specialty
            }
        },

    };
}

export function adminPatchSpecialty(specialty) {
    return {
        type: API_ADMIN_PATCH_SPECIALTY,
        payload: {
            request: {
                url: `/admin/specialties/${specialty.id}`,
                method: "PATCH",
                data: specialty
            }
        },

    };
}

export function adminDeleteSpecialty(specialty) {
    return {
        type: API_ADMIN_DELETE_SPECIALTY,
        payload: {
            request: {
                url: `/admin/specialties/${specialty.id}`,
                method: "DELETE"
            }
        },

    };
}

export function initNewSpecialty() {
	return {
		type: ADMIN_INIT_NEW_SPECIALTY
	};
}

export function resetFocusSpecialty() {
	return {
		type: ADMIN_RESET_FOCUS_SPECIALTY
	};
}
